import { render } from "./project_market_share.vue?vue&type=template&id=3b6526da&scoped=true"
import script from "./project_market_share.vue?vue&type=script&lang=js"
export * from "./project_market_share.vue?vue&type=script&lang=js"

import "./project_market_share.vue?vue&type=style&index=0&id=3b6526da&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6526da"]])

export default __exports__